var $f114a6a0dcc9e764$exports = {};
$f114a6a0dcc9e764$exports = {
    "collectionLabel": `Suggerimenti`
};


export {$f114a6a0dcc9e764$exports as default};
//# sourceMappingURL=it-IT.module.js.map
